"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d, _e, _f, _g;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VMRuntimeCodeHelper = void 0;
const inversify_1 = require("inversify");
const ServiceIdentifiers_1 = require("../../container/ServiceIdentifiers");
const TIdentifierNamesGeneratorFactory_1 = require("../../types/container/generators/TIdentifierNamesGeneratorFactory");
const ICustomCodeHelperFormatter_1 = require("../../interfaces/custom-code-helpers/ICustomCodeHelperFormatter");
const ICustomCodeHelperObfuscator_1 = require("../../interfaces/custom-code-helpers/ICustomCodeHelperObfuscator");
const IOptions_1 = require("../../interfaces/options/IOptions");
const IRandomGenerator_1 = require("../../interfaces/utils/IRandomGenerator");
const IVMBytecodeStorage_1 = require("../../interfaces/vm-transformers/IVMBytecodeStorage");
const IVMOpcodeMap_1 = require("../../interfaces/vm-transformers/IVMOpcodeMap");
const Initializable_1 = require("../../decorators/Initializable");
const VMRuntimeTemplate_1 = require("./templates/VMRuntimeTemplate");
const VMOpcodeDerivationTemplate_1 = require("./templates/VMOpcodeDerivationTemplate");
const VMStateMachineTemplate_1 = require("./templates/VMStateMachineTemplate");
const VMBytecodeArrayEncodingTemplate_1 = require("./templates/VMBytecodeArrayEncodingTemplate");
const VMBinaryBytecodeEncoder_1 = require("./templates/VMBinaryBytecodeEncoder");
const VMBinaryBytecodeDecoder_1 = require("./templates/VMBinaryBytecodeDecoder");
const VMBytecodeFormat_1 = require("../../enums/vm-transformers/VMBytecodeFormat");
const VMStateMachine_1 = require("../../vm-transformers/VMStateMachine");
const AbstractCustomCodeHelper_1 = require("../AbstractCustomCodeHelper");
const NodeGuards_1 = require("../../node/NodeGuards");
const NodeMetadata_1 = require("../../node/NodeMetadata");
const NodeUtils_1 = require("../../node/NodeUtils");
const ObfuscationTarget_1 = require("../../enums/ObfuscationTarget");
let VMRuntimeCodeHelper = class VMRuntimeCodeHelper extends AbstractCustomCodeHelper_1.AbstractCustomCodeHelper {
    constructor(identifierNamesGeneratorFactory, customCodeHelperFormatter, customCodeHelperObfuscator, randomGenerator, options) {
        super(identifierNamesGeneratorFactory, customCodeHelperFormatter, customCodeHelperObfuscator, randomGenerator, options);
        this.bytecodeKeyMapping = null;
        this.vmKeyMappingName = '';
    }
    initialize(vmBytecodeStorage, vmOpcodeMapStorage, vmExecutorName) {
        this.vmBytecodeStorage = vmBytecodeStorage;
        this.vmOpcodeMapStorage = vmOpcodeMapStorage;
        this.vmExecutorName = vmExecutorName;
        this.vmAsyncExecutorName = this.identifierNamesGenerator.generateNext();
        this.identifierNamesGenerator.preserveName(this.vmAsyncExecutorName);
        this.vmSyncExecutorName = this.identifierNamesGenerator.generateNext();
        this.identifierNamesGenerator.preserveName(this.vmSyncExecutorName);
        this.vmGeneratorExecutorName = this.identifierNamesGenerator.generateNext();
        this.identifierNamesGenerator.preserveName(this.vmGeneratorExecutorName);
        this.vmGlobalsName = '';
        this.vmBytecodeArrayName = '';
        this.vmOpcodeMapName = '';
        this.vmModuleVarsName = '';
    }
    getVMGlobalsName() {
        return this.vmGlobalsName;
    }
    getCodeHelperTemplate() {
        if (!this.vmBytecodeArrayName) {
            this.vmBytecodeArrayName = this.identifierNamesGenerator.generateNext();
        }
        if (!this.vmOpcodeMapName) {
            this.vmOpcodeMapName = this.identifierNamesGenerator.generateNext();
        }
        if (!this.vmGlobalsName) {
            const baseName = this.identifierNamesGenerator.generateForGlobalScope();
            const randomSuffix = Math.floor(this.randomGenerator.getMathRandom() * 16777215).toString(16);
            this.vmGlobalsName = `${baseName}_${randomSuffix}`;
        }
        if (!this.vmModuleVarsName) {
            this.vmModuleVarsName = this.identifierNamesGenerator.generateNext();
        }
        if (this.options.vmRandomizeKeys && !this.bytecodeKeyMapping) {
            this.bytecodeKeyMapping = this.generateBytecodeKeyMapping();
            this.vmKeyMappingName = this.identifierNamesGenerator.generateNext();
        }
        const opcodeDerivationFunctions = this.options.vmRuntimeOpcodeDerivation ? (0, VMOpcodeDerivationTemplate_1.getOpcodeDerivationTemplate)() : '';
        const opcodeDerivationInit = this.options.vmRuntimeOpcodeDerivation ? (0, VMOpcodeDerivationTemplate_1.getOpcodeDerivationInitTemplate)() : '';
        const stateMachineFunctions = this.options.vmStatefulOpcodes ? (0, VMStateMachineTemplate_1.getStateMachineFunctionsTemplate)() : '';
        const keySmSeed = this.bytecodeKeyMapping ? `${this.vmKeyMappingName}.smSeed` : '\'smSeed\'';
        const keySeKey = this.bytecodeKeyMapping ? `${this.vmKeyMappingName}.seKey` : '\'seKey\'';
        let stateMachineInit = this.options.vmStatefulOpcodes
            ? (0, VMStateMachineTemplate_1.getStateMachineInitTemplate)()
            : `
                // State machine disabled - define null placeholders
                var _smSeed = 0;
                var _smStateMaps = null;
`;
        stateMachineInit = stateMachineInit.replace(/\{keySmSeed\}/g, keySmSeed);
        let stackEncodingInit = this.options.vmStackEncoding ? (0, VMStateMachineTemplate_1.getStackEncodingInitTemplate)() : '';
        stackEncodingInit = stackEncodingInit.replace(/\{keySeKey\}/g, keySeKey);
        const keyMappingDeclaration = this.bytecodeKeyMapping
            ? `var ${this.vmKeyMappingName}=${this.serializeKeyMapping()};`
            : '';
        const keyI = this.bytecodeKeyMapping ? `${this.vmKeyMappingName}.i` : '\'i\'';
        const keyC = this.bytecodeKeyMapping ? `${this.vmKeyMappingName}.c` : '\'c\'';
        const keyP = this.bytecodeKeyMapping ? `${this.vmKeyMappingName}.p` : '\'p\'';
        const keyL = this.bytecodeKeyMapping ? `${this.vmKeyMappingName}.l` : '\'l\'';
        const keyJ = this.bytecodeKeyMapping ? `${this.vmKeyMappingName}.j` : '\'j\'';
        const keyX = this.bytecodeKeyMapping ? `${this.vmKeyMappingName}.x` : '\'x\'';
        const keyA = this.bytecodeKeyMapping ? `${this.vmKeyMappingName}.a` : '\'a\'';
        const keyO = this.bytecodeKeyMapping ? `${this.vmKeyMappingName}.o` : '\'o\'';
        const keyJk = this.bytecodeKeyMapping ? `${this.vmKeyMappingName}.jk` : '\'jk\'';
        const keyBk = this.bytecodeKeyMapping ? `${this.vmKeyMappingName}.bk` : '\'bk\'';
        const keyNi = this.bytecodeKeyMapping ? `${this.vmKeyMappingName}.ni` : '\'ni\'';
        const keyG = this.bytecodeKeyMapping ? `${this.vmKeyMappingName}.g` : '\'g\'';
        const keyS = this.bytecodeKeyMapping ? `${this.vmKeyMappingName}.s` : '\'s\'';
        let bytecodeArrayEncodingFunctions = '';
        let bytecodePreprocessing = '';
        let binaryDecoderFunctions = '';
        const useBinaryFormat = this.options.vmBytecodeFormat === VMBytecodeFormat_1.VMBytecodeFormat.Binary;
        const keyMappingRef = this.bytecodeKeyMapping ? this.vmKeyMappingName : 'null';
        const encodingTemplateParams = {
            vmBytecodeArrayName: this.vmBytecodeArrayName,
            keyC,
            keyMappingRef
        };
        if (useBinaryFormat) {
            binaryDecoderFunctions = (0, VMBinaryBytecodeDecoder_1.getBinaryBytecodeDecoderTemplate)();
        }
        if (this.options.vmBytecodeArrayEncoding) {
            let encodingTemplate = (0, VMBytecodeArrayEncodingTemplate_1.getBytecodeArrayEncodingTemplate)();
            if (useBinaryFormat) {
                encodingTemplate = this.getBinaryWithRC4EncodingTemplate();
            }
            bytecodeArrayEncodingFunctions = this.customCodeHelperFormatter.formatTemplate(encodingTemplate, encodingTemplateParams);
        }
        else if (useBinaryFormat) {
            bytecodeArrayEncodingFunctions = this.customCodeHelperFormatter.formatTemplate((0, VMBinaryBytecodeDecoder_1.getBinaryBytecodeAccessTemplate)(), encodingTemplateParams);
        }
        else {
            bytecodeArrayEncodingFunctions = this.customCodeHelperFormatter.formatTemplate((0, VMBytecodeArrayEncodingTemplate_1.getDirectBytecodeAccessTemplate)(), encodingTemplateParams);
            bytecodePreprocessing = this.customCodeHelperFormatter.formatTemplate((0, VMBytecodeArrayEncodingTemplate_1.getBigIntPreprocessingTemplate)(), encodingTemplateParams);
        }
        const isNodeTarget = this.options.target === ObfuscationTarget_1.ObfuscationTarget.Node;
        const splitDispatcher = this.options.vmSplitDispatcher;
        const macroOps = this.options.vmMacroOps;
        const indirectDispatch = this.options.vmIndirectDispatch;
        const formattedTemplate = this.customCodeHelperFormatter.formatTemplate((0, VMRuntimeTemplate_1.VMRuntimeTemplate)({ isNodeTarget, splitDispatcher, macroOps, indirectDispatch }), {
            vmBytecodeArrayName: this.vmBytecodeArrayName,
            vmOpcodeMapName: this.vmOpcodeMapName,
            vmGlobalsName: this.vmGlobalsName,
            vmGlobalsNameString: `'${this.vmGlobalsName}'`,
            vmModuleVarsName: this.vmModuleVarsName,
            vmExecutorName: this.vmExecutorName,
            vmSyncExecutorName: this.vmSyncExecutorName,
            vmAsyncExecutorName: this.vmAsyncExecutorName,
            vmGeneratorExecutorName: this.vmGeneratorExecutorName,
            bytecodeArray: this.serializeBytecode(),
            opcodeMapping: this.serializeOpcodeMapping(),
            dbgEnabled: this.options.vmDebugProtection ? 'true' : 'false',
            opcodeDerivationFunctions,
            opcodeDerivationInit,
            stateMachineFunctions,
            stateMachineInit,
            stackEncodingInit,
            keyMappingDeclaration,
            binaryDecoderFunctions,
            bytecodeArrayEncodingFunctions,
            bytecodePreprocessing,
            keyI,
            keyC,
            keyP,
            keyL,
            keyJ,
            keyX,
            keyA,
            keyO,
            keyJk,
            keyBk,
            keyNi,
            keyG,
            keyS
        });
        return formattedTemplate;
    }
    getNodeStructure(codeHelperTemplate) {
        const nodes = NodeUtils_1.NodeUtils.convertCodeToStructure(codeHelperTemplate);
        this.markBytecodeConstantsAsVerbatim(nodes);
        return nodes;
    }
    generateBytecodeKeyMapping() {
        const standardKeys = [
            'i',
            'c',
            'p',
            'l',
            'j',
            'x',
            'a',
            's',
            'g',
            'ni',
            'os',
            'o',
            'jk',
            'bk',
            'smSeed',
            'smState',
            'seKey'
        ];
        const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
        const usedKeys = new Set();
        const mapping = {};
        for (const key of standardKeys) {
            let randomKey;
            do {
                const c1 = chars[this.randomGenerator.getRandomInteger(0, chars.length - 1)];
                const c2 = chars[this.randomGenerator.getRandomInteger(0, chars.length - 1)];
                randomKey = c1 + c2;
            } while (usedKeys.has(randomKey));
            usedKeys.add(randomKey);
            mapping[key] = randomKey;
        }
        return mapping;
    }
    serializeKeyMapping() {
        if (!this.bytecodeKeyMapping) {
            return '';
        }
        const entries = Object.entries(this.bytecodeKeyMapping).map(([standardKey, randomKey]) => `${standardKey}:'${randomKey}'`);
        return `{${entries.join(',')}}`;
    }
    markBytecodeConstantsAsVerbatim(node, visited = new Set()) {
        if (Array.isArray(node)) {
            node.forEach((n) => this.markBytecodeConstantsAsVerbatim(n, visited));
            return;
        }
        if (!node || typeof node !== 'object') {
            return;
        }
        if (visited.has(node)) {
            return;
        }
        visited.add(node);
        if (NodeGuards_1.NodeGuards.isLiteralNode(node) && typeof node.value === 'string') {
            NodeMetadata_1.NodeMetadata.set(node, { ignoredNode: true });
            NodeUtils_1.NodeUtils.addXVerbatimPropertyTo(node);
        }
        for (const key in node) {
            if (key === 'parent' || key === 'metadata' || key === 'x-verbatim-property') {
                continue;
            }
            const value = node[key];
            if (value && typeof value === 'object') {
                this.markBytecodeConstantsAsVerbatim(value, visited);
            }
        }
    }
    serializeBytecode() {
        const allBytecode = this.vmBytecodeStorage.getAllBytecode();
        if (allBytecode.length === 0) {
            return '[]';
        }
        const useBinaryFormat = this.options.vmBytecodeFormat === VMBytecodeFormat_1.VMBytecodeFormat.Binary;
        const serializedBytecodes = allBytecode.map((bytecode) => {
            const smConfig = this.options.vmStatefulOpcodes && bytecode.smSeed !== undefined && bytecode.smState !== undefined
                ? (0, VMStateMachine_1.deriveStateMachineConfig)(bytecode.smSeed, bytecode.smState, 0)
                : undefined;
            const { flatInstructions, jumpTargets, exceptionHandlers } = this.serializeInstructionsFlat(bytecode.instructions, bytecode.jumpKey, bytecode.bytecodeKey, smConfig);
            const keyI = this.bytecodeKeyMapping ? this.bytecodeKeyMapping.i : 'i';
            const keyC = this.bytecodeKeyMapping ? this.bytecodeKeyMapping.c : 'c';
            const keyP = this.bytecodeKeyMapping ? this.bytecodeKeyMapping.p : 'p';
            const keyL = this.bytecodeKeyMapping ? this.bytecodeKeyMapping.l : 'l';
            const keyJ = this.bytecodeKeyMapping ? this.bytecodeKeyMapping.j : 'j';
            const keyX = this.bytecodeKeyMapping ? this.bytecodeKeyMapping.x : 'x';
            const keyA = this.bytecodeKeyMapping ? this.bytecodeKeyMapping.a : 'a';
            const keyS = this.bytecodeKeyMapping ? this.bytecodeKeyMapping.s : 's';
            const keyG = this.bytecodeKeyMapping ? this.bytecodeKeyMapping.g : 'g';
            const keyNi = this.bytecodeKeyMapping ? this.bytecodeKeyMapping.ni : 'ni';
            const keyOs = this.bytecodeKeyMapping ? this.bytecodeKeyMapping.os : 'os';
            const keyO = this.bytecodeKeyMapping ? this.bytecodeKeyMapping.o : 'o';
            const keyJk = this.bytecodeKeyMapping ? this.bytecodeKeyMapping.jk : 'jk';
            const keyBk = this.bytecodeKeyMapping ? this.bytecodeKeyMapping.bk : 'bk';
            const keySmSeed = this.bytecodeKeyMapping ? this.bytecodeKeyMapping.smSeed : 'smSeed';
            const keySmState = this.bytecodeKeyMapping ? this.bytecodeKeyMapping.smState : 'smState';
            const keySeKey = this.bytecodeKeyMapping ? this.bytecodeKeyMapping.seKey : 'seKey';
            const bytecodeObj = this.buildBytecodeObject(bytecode, flatInstructions, jumpTargets, exceptionHandlers, smConfig);
            if (useBinaryFormat && !this.options.vmBytecodeArrayEncoding) {
                const binaryBytecode = this.buildBinaryBytecodeObject(bytecode, smConfig);
                const binaryBuffer = (0, VMBinaryBytecodeEncoder_1.encodeBytecodeToBuffer)(binaryBytecode, this.bytecodeKeyMapping);
                const base64 = (0, VMBinaryBytecodeEncoder_1.bufferToBase64)(binaryBuffer);
                return JSON.stringify(base64);
            }
            if (this.options.vmBytecodeArrayEncoding) {
                let dataToEncrypt;
                if (useBinaryFormat) {
                    const binaryBytecode = this.buildBinaryBytecodeObject(bytecode, smConfig);
                    const binaryBuffer = (0, VMBinaryBytecodeEncoder_1.encodeBytecodeToBuffer)(binaryBytecode, this.bytecodeKeyMapping);
                    dataToEncrypt = (0, VMBinaryBytecodeEncoder_1.bufferToBase64)(binaryBuffer);
                }
                else {
                    dataToEncrypt = JSON.stringify(bytecodeObj);
                }
                const envKey = (0, VMBytecodeArrayEncodingTemplate_1.computeEnvironmentKey)();
                const keyStr = envKey.toString(16);
                const encrypted = (0, VMBytecodeArrayEncodingTemplate_1.rc4Encrypt)(dataToEncrypt, keyStr);
                const base64 = encrypted.toString('base64');
                return JSON.stringify(base64);
            }
            let result = '{' +
                `${keyI}:${flatInstructions},` +
                `${keyC}:${this.serializeConstants(bytecode.constants)},` +
                `${keyP}:${bytecode.params},` +
                `${keyL}:${bytecode.locals}`;
            if (jumpTargets) {
                result += `,${keyJ}:${jumpTargets}`;
            }
            if (exceptionHandlers) {
                result += `,${keyX}:${exceptionHandlers}`;
            }
            if (bytecode.isArrow) {
                result += `,${keyA}:1`;
            }
            if (bytecode.isAsync) {
                result += `,${keyS}:1`;
            }
            if (bytecode.isGenerator) {
                result += `,${keyG}:1`;
            }
            if (bytecode.functionNameIndex !== undefined) {
                result += `,${keyNi}:${bytecode.functionNameIndex}`;
            }
            if (bytecode.opcodeSeed !== undefined && this.options.vmRuntimeOpcodeDerivation) {
                result += `,${keyOs}:${bytecode.opcodeSeed}`;
            }
            else if (bytecode.opcodeMap) {
                const entries = Object.entries(bytecode.opcodeMap).map(([logical, randomized]) => {
                    return `${logical}:${randomized}`;
                });
                result += `,${keyO}:{${entries.join(',')}}`;
            }
            if (bytecode.jumpKey !== undefined) {
                result += `,${keyJk}:${bytecode.jumpKey}`;
            }
            if (bytecode.bytecodeKey !== undefined) {
                result += `,${keyBk}:${bytecode.bytecodeKey}`;
            }
            if (bytecode.smSeed !== undefined) {
                result += `,${keySmSeed}:${bytecode.smSeed}`;
            }
            if (bytecode.smState !== undefined) {
                result += `,${keySmState}:${bytecode.smState}`;
            }
            if (bytecode.seKey !== undefined) {
                result += `,${keySeKey}:${bytecode.seKey}`;
            }
            result += '}';
            return result;
        });
        return `[${serializedBytecodes.join(',')}]`;
    }
    serializeInstructionsFlat(instructions, jumpKey, bytecodeKey, smConfig) {
        const flat = [];
        const jumps = {};
        const exceptions = {};
        let hasJumps = false;
        let hasExceptions = false;
        instructions.forEach((instr, index) => {
            var _a, _b, _c;
            const logicalOpcode = instr.op;
            let opcode = logicalOpcode;
            if (smConfig) {
                const state = (0, VMStateMachine_1.computeState)(smConfig.seed, index);
                opcode = smConfig.stateMaps[state][logicalOpcode];
            }
            if (bytecodeKey !== undefined) {
                opcode = opcode ^ bytecodeKey;
            }
            flat.push(opcode);
            if (instr.arg !== undefined) {
                if (instr.arg2 !== undefined && typeof instr.arg === 'number') {
                    const packedArg = (instr.arg2 << 16) | instr.arg;
                    if (bytecodeKey !== undefined) {
                        flat.push(packedArg ^ bytecodeKey);
                    }
                    else {
                        flat.push(packedArg);
                    }
                }
                else if (typeof instr.arg === 'string') {
                    flat.push(JSON.stringify(instr.arg));
                }
                else if (typeof instr.arg === 'number' && bytecodeKey !== undefined) {
                    flat.push(instr.arg ^ bytecodeKey);
                }
                else {
                    flat.push(instr.arg);
                }
            }
            else {
                flat.push('null');
            }
            if (instr.target !== undefined) {
                jumps[index] = jumpKey !== undefined ? instr.target ^ jumpKey : instr.target;
                hasJumps = true;
            }
            if (instr.catchIndex !== undefined || instr.finallyIndex !== undefined || instr.endIndex !== undefined) {
                const catchVal = (_a = instr.catchIndex) !== null && _a !== void 0 ? _a : -1;
                const finallyVal = (_b = instr.finallyIndex) !== null && _b !== void 0 ? _b : -1;
                const endVal = (_c = instr.endIndex) !== null && _c !== void 0 ? _c : -1;
                exceptions[index] = [
                    jumpKey !== undefined && catchVal >= 0 ? catchVal ^ jumpKey : catchVal,
                    jumpKey !== undefined && finallyVal >= 0 ? finallyVal ^ jumpKey : finallyVal,
                    jumpKey !== undefined && endVal >= 0 ? endVal ^ jumpKey : endVal
                ];
                hasExceptions = true;
            }
        });
        const flatInstructions = `[${flat.join(',')}]`;
        let jumpTargets = null;
        if (hasJumps) {
            const jumpEntries = Object.entries(jumps)
                .map(([idx, target]) => `${idx}:${target}`)
                .join(',');
            jumpTargets = `{${jumpEntries}}`;
        }
        let exceptionHandlers = null;
        if (hasExceptions) {
            const exEntries = Object.entries(exceptions)
                .map(([idx, vals]) => `${idx}:[${vals.join(',')}]`)
                .join(',');
            exceptionHandlers = `{${exEntries}}`;
        }
        return { flatInstructions, jumpTargets, exceptionHandlers };
    }
    serializeConstants(constants) {
        const processedConstants = constants.map((c) => {
            if (typeof c === 'bigint') {
                return `${c.toString()}n`;
            }
            return c;
        });
        return JSON.stringify(processedConstants);
    }
    serializeOpcodeMapping() {
        const mapping = this.vmOpcodeMapStorage.getMappingObject();
        const entries = Object.entries(mapping).map(([logical, randomized]) => {
            return `${logical}:${randomized}`;
        });
        return `{${entries.join(',')}}`;
    }
    buildBytecodeObject(bytecode, flatInstructions, jumpTargets, exceptionHandlers, smConfig) {
        const keyI = this.bytecodeKeyMapping ? this.bytecodeKeyMapping.i : 'i';
        const keyC = this.bytecodeKeyMapping ? this.bytecodeKeyMapping.c : 'c';
        const keyP = this.bytecodeKeyMapping ? this.bytecodeKeyMapping.p : 'p';
        const keyL = this.bytecodeKeyMapping ? this.bytecodeKeyMapping.l : 'l';
        const keyJ = this.bytecodeKeyMapping ? this.bytecodeKeyMapping.j : 'j';
        const keyX = this.bytecodeKeyMapping ? this.bytecodeKeyMapping.x : 'x';
        const keyA = this.bytecodeKeyMapping ? this.bytecodeKeyMapping.a : 'a';
        const keyS = this.bytecodeKeyMapping ? this.bytecodeKeyMapping.s : 's';
        const keyG = this.bytecodeKeyMapping ? this.bytecodeKeyMapping.g : 'g';
        const keyNi = this.bytecodeKeyMapping ? this.bytecodeKeyMapping.ni : 'ni';
        const keyOs = this.bytecodeKeyMapping ? this.bytecodeKeyMapping.os : 'os';
        const keyO = this.bytecodeKeyMapping ? this.bytecodeKeyMapping.o : 'o';
        const keyJk = this.bytecodeKeyMapping ? this.bytecodeKeyMapping.jk : 'jk';
        const keyBk = this.bytecodeKeyMapping ? this.bytecodeKeyMapping.bk : 'bk';
        const keySmSeed = this.bytecodeKeyMapping ? this.bytecodeKeyMapping.smSeed : 'smSeed';
        const keySmState = this.bytecodeKeyMapping ? this.bytecodeKeyMapping.smState : 'smState';
        const keySeKey = this.bytecodeKeyMapping ? this.bytecodeKeyMapping.seKey : 'seKey';
        const parsedInstructions = new Function(`return ${flatInstructions}`)();
        const parsedJumps = jumpTargets ? new Function(`return ${jumpTargets}`)() : undefined;
        const parsedExceptions = exceptionHandlers ? new Function(`return ${exceptionHandlers}`)() : undefined;
        const processedConstants = bytecode.constants.map((c) => {
            if (typeof c === 'bigint') {
                return `${c.toString()}n`;
            }
            return c;
        });
        const obj = {
            [keyI]: parsedInstructions,
            [keyC]: processedConstants,
            [keyP]: bytecode.params,
            [keyL]: bytecode.locals
        };
        if (parsedJumps) {
            obj[keyJ] = parsedJumps;
        }
        if (parsedExceptions) {
            obj[keyX] = parsedExceptions;
        }
        if (bytecode.isArrow) {
            obj[keyA] = 1;
        }
        if (bytecode.isAsync) {
            obj[keyS] = 1;
        }
        if (bytecode.isGenerator) {
            obj[keyG] = 1;
        }
        if (bytecode.functionNameIndex !== undefined) {
            obj[keyNi] = bytecode.functionNameIndex;
        }
        if (bytecode.opcodeSeed !== undefined && this.options.vmRuntimeOpcodeDerivation) {
            obj[keyOs] = bytecode.opcodeSeed;
        }
        else if (bytecode.opcodeMap) {
            obj[keyO] = bytecode.opcodeMap;
        }
        if (bytecode.jumpKey !== undefined) {
            obj[keyJk] = bytecode.jumpKey;
        }
        if (bytecode.bytecodeKey !== undefined) {
            obj[keyBk] = bytecode.bytecodeKey;
        }
        if (bytecode.smSeed !== undefined) {
            obj[keySmSeed] = bytecode.smSeed;
        }
        if (bytecode.smState !== undefined) {
            obj[keySmState] = bytecode.smState;
        }
        if (bytecode.seKey !== undefined) {
            obj[keySeKey] = bytecode.seKey;
        }
        return obj;
    }
    getBinaryWithRC4EncodingTemplate() {
        return `
            // Environment-based key derivation (must match compile-time computeEnvironmentKey)
            function _envKey() {
                var key = 0;
                try {
                    key ^= (Function.prototype.toString.call(Array.prototype.push).length << 16);
                    key ^= (Function.prototype.toString.call(Object.keys).length << 8);
                    key ^= Function.prototype.toString.call(Math.abs).length;
                } catch (e) {
                    key ^= 0x12345678;
                }
                key ^= (Array.prototype.slice.length << 24);
                key ^= (String.prototype.charAt.length << 20);
                // Mix bits (MurmurHash3 finalizer)
                key ^= (key >>> 16);
                key = Math.imul(key, 0x85EBCA6B) >>> 0;
                key ^= (key >>> 13);
                key = Math.imul(key, 0xC2B2AE35) >>> 0;
                key ^= (key >>> 16);
                return key >>> 0;
            }

            // RC4 decrypt
            function _rc4Dec(str, key) {
                var s = [], j = 0, x, res = '';
                for (var i = 0; i < 256; i++) s[i] = i;
                for (var i = 0; i < 256; i++) {
                    j = (j + s[i] + key.charCodeAt(i % key.length)) % 256;
                    x = s[i]; s[i] = s[j]; s[j] = x;
                }
                var i = 0; j = 0;
                for (var y = 0; y < str.length; y++) {
                    i = (i + 1) % 256;
                    j = (j + s[i]) % 256;
                    x = s[i]; s[i] = s[j]; s[j] = x;
                    res += String.fromCharCode(str.charCodeAt(y) ^ s[(s[i] + s[j]) % 256]);
                }
                return res;
            }

            // Base64 decode (to binary string, preserving byte values)
            function _b64Dec(str) {
                if (typeof Buffer !== 'undefined') {
                    // Use latin1 to preserve byte values (not utf8 which corrupts binary data)
                    return Buffer.from(str, 'base64').toString('latin1');
                }
                // Browser: atob returns a binary string with byte values preserved
                return atob(str);
            }

            // Lazy decryption with binary decode
            var _decKey = _envKey().toString(16);
            var _bcCache = {};
            function _getBytecode(id) {
                if (_bcCache[id]) return _bcCache[id];
                var raw = {vmBytecodeArrayName}[id];
                if (typeof raw === 'string') {
                    // First RC4 decrypt
                    var decrypted = _rc4Dec(_b64Dec(raw), _decKey);
                    // Then binary decode (decrypted is base64 of binary data)
                    // Note: BigInt is handled natively by _decodeBinary via CT_BIGINT type tag
                    _bcCache[id] = _decodeBinary(decrypted, {keyMappingRef});
                } else {
                    _bcCache[id] = raw;
                }
                return _bcCache[id];
            }
`;
    }
    buildBinaryBytecodeObject(bytecode, smConfig) {
        const instructions = [];
        bytecode.instructions.forEach((instr, index) => {
            const logicalOpcode = instr.op;
            let opcode = logicalOpcode;
            if (smConfig) {
                const state = (0, VMStateMachine_1.computeState)(smConfig.seed, index);
                opcode = smConfig.stateMaps[state][logicalOpcode];
            }
            if (bytecode.bytecodeKey !== undefined) {
                opcode = opcode ^ bytecode.bytecodeKey;
            }
            const instrObj = { op: opcode };
            if (instr.arg !== undefined) {
                if (instr.arg2 !== undefined && typeof instr.arg === 'number') {
                    instrObj.arg = instr.arg;
                    instrObj.arg2 = instr.arg2;
                    if (bytecode.bytecodeKey !== undefined) {
                        instrObj.arg = instrObj.arg ^ bytecode.bytecodeKey;
                        instrObj.arg2 = instrObj.arg2;
                    }
                }
                else if (typeof instr.arg === 'string') {
                    instrObj.arg = instr.arg;
                }
                else if (typeof instr.arg === 'number' && bytecode.bytecodeKey !== undefined) {
                    instrObj.arg = instr.arg ^ bytecode.bytecodeKey;
                }
                else {
                    instrObj.arg = instr.arg;
                }
            }
            if (instr.target !== undefined) {
                instrObj.target = instr.target;
            }
            if (instr.catchIndex !== undefined || instr.finallyIndex !== undefined || instr.endIndex !== undefined) {
                if (instr.catchIndex !== undefined) {
                    instrObj.catchIndex = instr.catchIndex;
                }
                if (instr.finallyIndex !== undefined) {
                    instrObj.finallyIndex = instr.finallyIndex;
                }
                if (instr.endIndex !== undefined) {
                    instrObj.endIndex = instr.endIndex;
                }
            }
            instructions.push(instrObj);
        });
        const processedConstants = bytecode.constants.map((c) => {
            if (typeof c === 'string' && /^-?\d+n$/.test(c)) {
                try {
                    return BigInt(c.slice(0, -1));
                }
                catch (_a) {
                    return c;
                }
            }
            return c;
        });
        const result = {
            params: bytecode.params,
            locals: bytecode.locals,
            constants: processedConstants,
            instructions
        };
        if (bytecode.isArrow) {
            result.isArrow = true;
        }
        if (bytecode.isAsync) {
            result.isAsync = true;
        }
        if (bytecode.isGenerator) {
            result.isGenerator = true;
        }
        if (bytecode.functionNameIndex !== undefined) {
            result.functionNameIndex = bytecode.functionNameIndex;
        }
        if (bytecode.opcodeSeed !== undefined && this.options.vmRuntimeOpcodeDerivation) {
            result.opcodeSeed = bytecode.opcodeSeed;
        }
        else if (bytecode.opcodeMap) {
            result.opcodeMap = bytecode.opcodeMap;
        }
        if (bytecode.jumpKey !== undefined) {
            result.jumpKey = bytecode.jumpKey;
        }
        if (bytecode.bytecodeKey !== undefined) {
            result.bytecodeKey = bytecode.bytecodeKey;
        }
        if (bytecode.smSeed !== undefined) {
            result.smSeed = bytecode.smSeed;
        }
        if (bytecode.smState !== undefined) {
            result.smState = bytecode.smState;
        }
        if (bytecode.seKey !== undefined) {
            result.seKey = bytecode.seKey;
        }
        return result;
    }
};
exports.VMRuntimeCodeHelper = VMRuntimeCodeHelper;
__decorate([
    (0, Initializable_1.initializable)(),
    __metadata("design:type", typeof (_f = typeof IVMBytecodeStorage_1.IVMBytecodeStorage !== "undefined" && IVMBytecodeStorage_1.IVMBytecodeStorage) === "function" ? _f : Object)
], VMRuntimeCodeHelper.prototype, "vmBytecodeStorage", void 0);
__decorate([
    (0, Initializable_1.initializable)(),
    __metadata("design:type", typeof (_g = typeof IVMOpcodeMap_1.IVMOpcodeMapStorage !== "undefined" && IVMOpcodeMap_1.IVMOpcodeMapStorage) === "function" ? _g : Object)
], VMRuntimeCodeHelper.prototype, "vmOpcodeMapStorage", void 0);
__decorate([
    (0, Initializable_1.initializable)(),
    __metadata("design:type", String)
], VMRuntimeCodeHelper.prototype, "vmExecutorName", void 0);
__decorate([
    (0, Initializable_1.initializable)(),
    __metadata("design:type", String)
], VMRuntimeCodeHelper.prototype, "vmAsyncExecutorName", void 0);
__decorate([
    (0, Initializable_1.initializable)(),
    __metadata("design:type", String)
], VMRuntimeCodeHelper.prototype, "vmSyncExecutorName", void 0);
__decorate([
    (0, Initializable_1.initializable)(),
    __metadata("design:type", String)
], VMRuntimeCodeHelper.prototype, "vmGeneratorExecutorName", void 0);
__decorate([
    (0, Initializable_1.initializable)(),
    __metadata("design:type", String)
], VMRuntimeCodeHelper.prototype, "vmGlobalsName", void 0);
__decorate([
    (0, Initializable_1.initializable)(),
    __metadata("design:type", String)
], VMRuntimeCodeHelper.prototype, "vmBytecodeArrayName", void 0);
__decorate([
    (0, Initializable_1.initializable)(),
    __metadata("design:type", String)
], VMRuntimeCodeHelper.prototype, "vmOpcodeMapName", void 0);
__decorate([
    (0, Initializable_1.initializable)(),
    __metadata("design:type", String)
], VMRuntimeCodeHelper.prototype, "vmModuleVarsName", void 0);
exports.VMRuntimeCodeHelper = VMRuntimeCodeHelper = __decorate([
    (0, inversify_1.injectable)(),
    __param(0, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
    __param(1, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.ICustomCodeHelperFormatter)),
    __param(2, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.ICustomCodeHelperObfuscator)),
    __param(3, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IRandomGenerator)),
    __param(4, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IOptions)),
    __metadata("design:paramtypes", [typeof (_a = typeof TIdentifierNamesGeneratorFactory_1.TIdentifierNamesGeneratorFactory !== "undefined" && TIdentifierNamesGeneratorFactory_1.TIdentifierNamesGeneratorFactory) === "function" ? _a : Object, typeof (_b = typeof ICustomCodeHelperFormatter_1.ICustomCodeHelperFormatter !== "undefined" && ICustomCodeHelperFormatter_1.ICustomCodeHelperFormatter) === "function" ? _b : Object, typeof (_c = typeof ICustomCodeHelperObfuscator_1.ICustomCodeHelperObfuscator !== "undefined" && ICustomCodeHelperObfuscator_1.ICustomCodeHelperObfuscator) === "function" ? _c : Object, typeof (_d = typeof IRandomGenerator_1.IRandomGenerator !== "undefined" && IRandomGenerator_1.IRandomGenerator) === "function" ? _d : Object, typeof (_e = typeof IOptions_1.IOptions !== "undefined" && IOptions_1.IOptions) === "function" ? _e : Object])
], VMRuntimeCodeHelper);
